<template>
  <div v-if="accounts.length > 0">
    <div class="language-selector dropdown" v-dropdown.closeOnMenuClick v-if="accounts.length > 1 && policy.can('index')">
      <a class="language-selector-button dropdown-toggle" href="/" @click.prevent="closeMenu">
        {{ currentAccount() }}&nbsp;<i class="fa fa-caret-down" />
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width: auto !important; min-width: 16rem !important;">
        <scrollbar ref="scrollbar">
          <div class="dropdown-menu-content">
            <a
              class="dropdown-item"
              :class="{ active: account.id === currentAccount() }"
              v-for="(account, id) in accounts"
              :key="id"
              @click="setAccount(account.id)"
            >
              <span class="dropdown-item-text ellipsis">
                {{ account.id }} - {{ account.name }}
              </span>
            </a>
          </div>
        </scrollbar>
      </div>
    </div>
    <div class="language-selector" v-else>
      <a class="language-selector-button" href="/">
        {{ currentAccount() }}
      </a>
    </div>
  </div>
</template>

<script>
  // import Vue from 'vue'
  import { mapActions } from 'vuex'
  import axios from 'axios'
  import client from '../../../fractel/clients/Myriander.js'
  import fonestormClient from '../../../fractel/clients/FoneStorm/FoneStorm.vue'
  import Scrollbar from '../../../vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue'
  import store from '../../../store'
  import Policy from '@/policy'

  export default {
    name: 'account-selector',

    mounted: function () {
      this.getAccounts()
    },

    components: {
      Scrollbar
    },

    data () {
      return {
        accounts: [],
        selected: '',
        policy: Policy.SubAccount
      }
    },

    methods: {
      ...mapActions(['closeMenu']),

      setAccount (account) {
        var self = this
        if (account !== localStorage.getItem('fonestorm-parent-account')) {
          store.commit('setLoading', true)
          const path = '/sub_accounts/token'
          const url = client.methods.api_url(path)
          const options = client.methods.api_options()
          options.headers.Authorization = `Bearer ${localStorage.getItem('fonestorm-parent-token')}`
          const payload = { id: account }
          axios.post(url, payload, options)
          .then(async function (response) {
            localStorage.setItem('fonestorm-account', account)
            localStorage.setItem('fonestorm-username', account)
            localStorage.setItem('fonestorm-token', response.data.token)
            self.$router.go({
              path: '/',
              force: true
            })
          })
          .catch(function (error) {
            store.commit('setLoading', false)
            console.log(error)
            if (error.response.status === 401) {
              self.$router.push({ name: 'Logout' })
            }
          })
        } else {
          store.commit('setLoading', true)
          localStorage.setItem('fonestorm-account', localStorage.getItem('fonestorm-parent-account'))
          localStorage.setItem('fonestorm-username', localStorage.getItem('fonestorm-parent-username'))
          localStorage.setItem('fonestorm-token', localStorage.getItem('fonestorm-parent-token'))
          self.$router.go({
            path: '/',
            force: true
          })
        }
      },

      currentAccount () {
        return localStorage.getItem('fonestorm-account')
      },

      getAccounts () {
        var self = this
        const path = '/subaccounts'
        const url = fonestormClient.methods.api_url(path)
        const options = fonestormClient.methods.api_options()
        options.headers.token = localStorage.getItem('fonestorm-parent-token')
        axios.get(url, options)
        .then(async function (response) {
          response.data.subaccounts.forEach((subaccount) => {
            if (subaccount.status !== 'disabled') {
              self.accounts.push({ id: subaccount.id, name: subaccount.label })
            }
          })
          self.accounts.push({ id: localStorage.getItem('fonestorm-parent-account'), name: 'Top Level Account' })
          self.selected = localStorage.getItem('fonestorm-account')

          // Sort account list
          self.accounts = self.accounts.sort(function (a, b) {
            return (a.id === b.id ? 0 : a.id > b.id ? 1 : -1)
          })
        })
        .catch(function (error) {
          console.log(error)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/variables";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .language-selector {
    display: flex;
    max-width: 100%;
    height: 100%;
    padding: 0;
    flex-basis: 0;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    .language-selector-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flag-icon-large {
      width: 31px;
      height: 23px;
    }

    .flag-icon-small {
      min-width: 22px;
      height: 17px;
    }

    .dropdown-toggle {
      padding: 0;

      &:after {
        display: none;
      }
    }

    &.show {
      &:after {
        position: absolute;
        right: calc(50% - 10px);
        bottom: -$dropdown-mobile-show-b;
        display: block;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid $fractel-teal;
        z-index: 2;
      }

      .dropdown-menu {
        left: auto;
        margin-top: $dropdown-mobile-show-b;

        &.last {
          right: 0;
        }

        @include media-breakpoint-up(lg) {
          right: auto;
          left: 12px;
          margin-top: 12px;
        }
      }
    }

    .dropdown-menu {
      min-width: 8rem;
      max-width: 11rem;
      margin-top: $dropdown-show-b;
      padding: 0;
      background-color: $dropdown-background;
      box-shadow: $dropdown-box-shadow;

      @include media-breakpoint-up(lg) {
        top: 42px;
      }
      .vuestic-scrollbar {
        height: $dropdown-item-height * 10;
      }
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      height: 38px;
      padding: 9px 12px;

      &.active {
        color: $vue-green;
        background-color: $fractel-teal;
      }

      &:hover {
        background-color: $fractel-dark-teal;
      }

      &:last-child {
        padding-top: 8px;
        padding-bottom: 10px;
      }
    }

    .dropdown-item-text {
      padding-left: 0;
      font-size: 5*$font-size-base/6;
      line-height: 1.25;
    }
  }

  .dropdown-item > a {
    color: $white;

    &.active {
      color: $lighter-gray;
    }

    &:hover {
      color: $lighter-gray;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/AccountSelector.vue